
















































































































































































































































































































































































interface Form {
  account: string | undefined;
  logo: string | undefined;
  qrcode: string | undefined;
  sell_name: string | undefined;
  sell_name_two: string | undefined;
  specify_ware_name: string | undefined;
  wechat: string | undefined;
  wx_app_name: string | undefined;
}
interface ModelForm {
  again_password: number | undefined;
  auth_code: string | undefined;
  first_code: string | undefined;
  new_account: number | undefined;
  new_password: number | undefined;
  old_account: string | undefined;
  second_code: string | undefined;
}
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SingleImageUpload from '@/component/single-image-upload.vue';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
const md5 = require('blueimp-md5');
import store from '@/store/index';
import { State, Mutation, Action } from 'vuex-class';
import { MUTATION_LOG_ON_OUT, ACTION_RELOAD_BASIS } from '@/store/type';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const UPLOAD_DIR = {
  setting: 'setting',
};
const VALIDATE = {
  is_first_code: false,
  is_new_account: false,
  is_second_code: false,
  is_password: false,
  is_again_password: false,
};
const API = {
  captcha: `${FCAPI}/shang/setting/captcha`,
  update_account: `${FCAPI}/shang/setting/account`,
  update_password: `${FCAPI}/shang/setting/password`,
  save_data: `${FCAPI}/shang/setting/profile`,
};

@Component({
  components: {
    SingleImageUpload,
  },
})
export default class BasicInfo extends Vue {
  @State('basis') basis!: Business.Basis;
  @Mutation(MUTATION_LOG_ON_OUT) logOnOut: any;
  @Action(ACTION_RELOAD_BASIS) globalReloadBasis!: () => void;
  account_err_msg: string = '* 请输入正确的手机号';
  auth_code_err_msg: string = '* 请输入验证码';
  first_auth_code: number = 60;
  form_item_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  form: Form = getForm();
  is_button_loading: boolean = true;
  is_loading: boolean = false;
  is_show_change_account_modal: boolean = false;
  is_show_change_password_modal: boolean = false;
  merchant_id: number = 0;
  modal_account_layout: any = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };
  modal_form: ModelForm = getModelForm();
  modal_password_layout: any = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };
  password_err_msg: string = '* 请重复输入新密码';
  package_type: number = 1;
  second_auth_code: number = 60;
  three_auth_code: number = 60;
  validate: any = VALIDATE;
  get uploadDir() {
    return UPLOAD_DIR;
  }
  @Watch('basis')
  onBasisMutate() {
    this.form = getForm(this.basis);
    this.modal_form.old_account = this.basis.mobile;
  }

  beforeLogoUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  beforeWechatUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  async updateAccount(type: string) {
    // type==account -->修改账户，type==password -->修改密码
    const model = this.modal_form;
    if (type === 'account') {
      if (!model.first_code) {
        this.validate.is_first_code = true;
        this.auth_code_err_msg = '* 请输入验证码';
        return;
      }
      if (model.first_code.length !== 6) {
        this.validate.is_first_code = true;
        this.auth_code_err_msg = '* 验证码格式错误，请重新输入';
        return;
      }
      if (model.new_account === model.old_account) {
        this.validate.is_new_account = true;
        this.account_err_msg = '* 新账户不能和原账户相同';
        return;
      }
      if (!model.new_account || !/^1[0-9]{10}$/.test(String(model.new_account))) {
        this.validate.is_new_account = true;
        this.account_err_msg = '* 请输入正确的手机号';
        return;
      }
      if (!model.second_code) {
        this.validate.is_second_code = true;
        this.auth_code_err_msg = '* 请输入验证码';
        return;
      }
      if (model.second_code.length !== 6) {
        this.validate.is_second_code = true;
        this.auth_code_err_msg = '* 验证码格式错误，请重新输入';
        return;
      }
    } else {
      if (!model.auth_code) {
        this.validate.is_first_code = true;
        this.auth_code_err_msg = '* 请输入验证码';
        return;
      }
      if (model.auth_code.length !== 6) {
        this.validate.is_first_code = true;
        this.auth_code_err_msg = '* 验证码格式错误，请重新输入';
        return;
      }
      if (!model.new_password) {
        this.validate.is_password = true;
        return;
      }
      if (!model.again_password) {
        this.validate.is_again_password = true;
        this.password_err_msg = '* 请重复输入新密码';
        return;
      }
      if (model.new_password !== model.again_password) {
        this.validate.is_again_password = true;
        this.password_err_msg = '* 该密码与新密码不相同，请重新输入';
        return;
      }
    }
    if (this.is_button_loading) {
      this.is_button_loading = false;
      const send_data: any = {};
      if (type === 'account') {
        send_data.mobile = model.old_account;
        send_data.mobile_captcha = model.first_code;
        send_data.new_mobile = model.new_account;
        send_data.new_mobile_captcha = model.second_code;
      } else {
        send_data.mobile = model.old_account;
        send_data.captcha = model.auth_code;
        send_data.password = md5(model.new_password);
      }

      const updateUrl = type === 'account' ? API.update_account : API.update_password;

      const res: AxiosResponse = await this.$axios.put(
        `${updateUrl}/${this.merchant_id}`,
        send_data
      );
      const remote = res.data;
      if (remote.status !== 200) {
        this.$message.error(remote.message);
        return;
      }
      this.is_show_change_account_modal = false;
      this.$message.success('修改成功，需重新登录');
      this.logOnOut(false);
      this.$router.push('/login');
      this.is_loading = false;
      this.is_button_loading = true;
    }
  }

  updateInput(type: string, key: string) {
    this.validate[type] = !(this.modal_form as any)[key];
    if (type === 'is_new_account') {
      this.validate[type] = !(this.modal_form as any)[key];
    }
  }

  cancelModal() {
    for (const key in this.validate) {
      if (this.validate[key]) {
        this.validate[key] = false;
      }
    }
  }

  async sendMessage(type: string) {
    // 获取验证码
    const mobile = type === 'second' ? this.modal_form.new_account : this.modal_form.old_account;

    const res: AxiosResponse = await this.$axios.post(API.captcha, {
      mobile,
    });

    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      return;
    }
    const timer = setInterval(() => {
      if (type === 'first') {
        this.first_auth_code -= 1;
        if (this.first_auth_code === 0) {
          clearInterval(timer);
          this.first_auth_code = 60;
        }
      } else if (type === 'second') {
        this.second_auth_code -= 1;
        if (this.second_auth_code === 0) {
          clearInterval(timer);
          this.second_auth_code = 60;
        }
      } else {
        this.three_auth_code -= 1;
        if (this.three_auth_code === 0) {
          clearInterval(timer);
          this.three_auth_code = 60;
        }
      }
    }, 1000);
  }

  async submit() {
    const form = this.form;
    if (form.wx_app_name && form.wx_app_name.length > 9) {
      return;
    }
    if (form.sell_name && form.sell_name.length > 6) {
      return;
    }
    if (form.sell_name_two && form.sell_name_two.length > 6) {
      return;
    }
    if (form.specify_ware_name && form.specify_ware_name.length > 4) {
      return;
    }
    this.is_loading = true;
    const send_data: any = {};
    send_data.logo = form.logo;
    send_data.wxapp_name = form.wx_app_name;
    send_data.role_name = form.sell_name;
    send_data.role_name_two = form.sell_name_two;
    send_data.guide_to_wx_qrcode = form.qrcode;
    send_data.guide_to_wx_id = form.wechat;
    send_data.specify_ware_name = form.specify_ware_name;
    this.is_loading = true;

    const res: AxiosResponse = await this.$axios.put(
      `${API.save_data}/${this.merchant_id}`,
      send_data
    );
    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      this.is_loading = false;
      return;
    }
    this.$message.success('保存成功');
    this.globalReloadBasis();
    this.is_loading = false;
  }

  created() {
    this.onBasisMutate();
    this.merchant_id = (storage.getItem('profile') || {}).merchant_id || 0;
    this.package_type = (storage.getItem('profile') || {}).package_type || 1;
  }
}

function getForm(remote: any = {}): Form {
  return {
    account: remote.mobile,
    logo: remote.logo,
    qrcode: remote.guide_to_wx_qrcode,
    sell_name: remote.role_name,
    sell_name_two: remote.role_name_two,
    specify_ware_name: remote.specify_ware_name,
    wechat: remote.guide_to_wx_id,
    wx_app_name: remote.wxapp_name,
  };
}

function getModelForm(remote: any = {}): ModelForm {
  return {
    old_account: remote.old_account,
    first_code: remote.first_code,
    new_account: remote.new_account,
    second_code: remote.second_code,
    auth_code: remote.auth_code,
    new_password: remote.new_password,
    again_password: remote.again_password,
  };
}
